import React from 'react';
import { Card } from 'react-bootstrap';

function VehicleInfoCard(props) {
    return (
        <>
            <Card className="card border-primary mb-3 mx-auto mt-3" style={{ maxWidth: '600px', width: '90%' }}>
                <Card.Body className="card-header">
                    <Card.Title className="card-title mt-2">
                        {props.year} {String(props.make)} {String(props.model)}
                    </Card.Title>

                    <div style={{ borderTop: '2px solid green', margin: '10px 0 20px' }}></div>           

                    <Card.Text>
                        <p><strong>VARIANT </strong><br/>{props.description}</p>
                        <p><strong>ENGINE </strong><br/>{props.cylinders} Cylinder {props.engine_size}L </p>
                        <p><strong>FUEL TYPE </strong><br/>
                        {String(props.fuel_type).split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</p>
                        <p><strong>TRANSMISSION </strong><br/>
                        {String(props.transmission).split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</p>
                        
                    </Card.Text>
                </Card.Body>
                <div className="m-2 fw-bold">If this is correct, hit 'Next'.</div>
            </Card>            
            
        </>
    );
}

export default VehicleInfoCard;